import { RestService } from "@sinossi/mates-react-library";

export class ZoneServices {
    static getFilteredZones = (request: { name: string }, callback: any, catchCallback: any) => {
        RestService
            .post<any>("/api/zones/filter", request)
            .then(callback)
            .catch(catchCallback)
    }

}
